import { saveAs } from 'file-saver';
import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { FileOpener } from '@capacitor-community/file-opener';

/**
 * Save blob response to file.
 * @param blob Blob to save.
 * @param fileName File name.
 */
export async function downloadFile(blob: Blob, fileName: string): Promise<void> {
  const fullName = `${fileName}.pdf`;

  if (Capacitor.isNativePlatform()) {
    // Convert blob to base64
    const base64 = await blobToBase64(blob);

    const result = await Filesystem.writeFile({
      path: fullName,
      data: base64,
      directory: Directory.Documents,
    });

    // Optionally open the file after saving
    await FileOpener.open({
      filePath: result.uri,
      contentType: 'application/pdf',
    });
  } else {
    saveAs(blob, fullName);
  }
}

function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result as string;
      // Remove the data:*/*;base64, prefix
      resolve(result.split(',')[1]);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
